import { TOUR_TRANSLATIONS } from "../translations"

export const getDigitalShelfGeneralSteps = (lang) => {
    const t = TOUR_TRANSLATIONS[lang]

    return [
        {
            target: '[data-tour="ds-general-filters"]',
            title: t.dsGeneralFilters.title,
            content: t.dsGeneralFilters.content,
            disableBeacon: true,
        },
        {
            target: '[data-tour="ds-general-table"]',
            title: t.dsGeneralTable.title,
            content: t.dsGeneralTable.content,
        },
        {
            target: '[data-tour="ds-general-create-report"]',
            title: t.dsGeneralCreateReport.title,
            content: t.dsGeneralCreateReport.content,
        },
    ]
}
